var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMedicalPolicy = function SvgMedicalPolicy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 62,
    viewBox: "0 0 50 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 60,
    rx: 5,
    stroke: "currentColor",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 35,
    width: 22,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 41,
    width: 16.9167,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 47,
    width: 11.5184,
    height: 2,
    rx: 1,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6534 13.1784C28.9463 11.4713 26.1734 11.4713 24.4663 13.1784L19.3466 18.298C17.6395 20.0052 17.6395 22.778 19.3466 24.4852C21.0538 26.1923 23.8266 26.1923 25.5338 24.4852L30.6534 19.3655C32.3605 17.6584 32.3605 14.8855 30.6534 13.1784ZM22.613 17.5062C22.7976 17.3215 23.0531 17.2262 23.313 17.2454C23.8363 17.3329 24.7445 17.5578 25.5093 18.3225C26.2775 19.0908 26.4954 20.0104 26.5549 20.538C26.5706 20.7892 26.4779 21.035 26.3003 21.2127C25.8689 21.6747 25 22.5444 25 22.5444L24.2965 23.2479C23.2719 24.2725 21.6085 24.2725 20.5839 23.2479C19.5593 22.2233 19.5593 20.5599 20.5839 19.5353L21.7966 18.3225C21.7966 18.3225 22.2936 17.8255 22.613 17.5062Z",
    fill: "currentColor"
  })));
};
export { SvgMedicalPolicy as ReactComponent };